import * as Yup from "yup";

export const asesoriaSchema = () => {
  return Yup.object().shape({
    name: Yup.string()
      .required("El campo es requerido")
      .trim(),
    empresa: Yup.string().required("El campo es requerido").trim(),
    phone: Yup.string()
      .required("El campo es requerido")
      .matches(/^\d{10}$/, "El campo solo admite números enteros y necesita ser de 10 dígitos")
      .trim(),
  });
};
